module.exports = __webpack_public_path__ + "static/media/onboarding7.1f76b3f7.svg";